module.exports = __webpack_public_path__ + "media/images/honeyfarm/farm_two-4775001d3c634a308cbbcf98d67ec0ab.jpg";